<template>
  <div class="option"
       :class="{
          selected: option.selected,
          disabled: option.disabled,
        }"
  >
    <div class="option__content"
         @click="select(option, $event)"
    >
      <FormCheckbox
          v-if="multiple"
          v-model="option.selected"
          label-disabled
          class="me-2 pointer-events-none"
      />

      <div v-else-if="option.selected"
           class="icon icon-check option__check"
      />

      <slot v-bind="{option}">
        <span class="text-truncate" v-tooltip="option[titleKey]">
          {{ option[titleKey] }}
        </span>
      </slot>
    </div>
  </div>
</template>
<script setup>
import FormCheckbox from "@/js/Elements/Form/FormCheckbox.vue";
import FormControlProps from "@/js/Elements/Form/FormControlProps.js";

const emit = defineEmits(['select']);
const props = defineProps({
  ...FormControlProps,
  option: Object
});

function select(option, e) {
  emit('select', option);
}
</script>
